/** @jsxRuntime classic */
/** @jsx jsx */
/** @jsxFrag Fragment */
import type { BoxProps } from '@mantine/core';
import { Box, Text } from '@mantine/core';
import { IconHeartFilled } from '@tabler/icons-react';
import React from 'react';
import { jsx } from 'theme-ui';

export default function FloorPlanAreaTooltip({
  children,
  isFavorite,
  ...rest
}: BoxProps & {
  children?: React.ReactNode;
  isFavorite?: boolean;
}) {
  if (!children) return null;
  if (isFavorite) {
    return (
      <Box display="flex" sx={{ gap: 2, alignItems: 'center' }} {...rest}>
        <Text size="xs">{children}</Text>
        <IconHeartFilled size={16} />
      </Box>
    );
  }
  return <Text size="xs">{children}</Text>;
}
